import { FC, createContext, ReactNode, useMemo, useState, useContext } from 'react';

interface Props {
  children?: ReactNode;
}

const ValueContext = createContext({} as ReturnType<typeof usePassedDownValues>);
ValueContext.displayName = 'ValueContext';

export const useFile = () => {
  const context = useContext(ValueContext);
  if (context === undefined) {
    throw new Error('useValue must be used within a ValueProvider');
  }
  return context;
};

const usePassedDownValues = () => {
  const [file, setFile] = useState<any>({});

  const values = useMemo(() => {
    return {
      file,
      setFile,
    };
  }, [file, setFile])

  return values;
};

const ValueProvider: FC<Props> = ({ children }) => {
  return <ValueContext.Provider value={usePassedDownValues()}>{children}</ValueContext.Provider>;
};

export default ValueProvider;
